import { WarehouseSettingsPanel } from './warehouse-settings/WarehouseSettingsPanel';
export function BusinessProfileSettings(){return <WarehouseSettingsPanel group="business"/>;}
